import './dataExtractor.scss';
import { blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant } from 'app.constants';
import { DataExtractorConstantsTracks } from './DataExtractorConstants';
import { AttendanceFeatures } from '../AttendanceFeatures';
export const attendanceReportStateName = 'auth.application.detail.attendance.report';
export const attendanceReportStateNameMfe = 'auth.application.detail.attendance.desk.report';
export class DataExtractorReportController {
    static $inject = ['AccountService2', 'ContextProcessorService', 'DATA_EXTRACTOR_FRAME_URL', 'DATA_EXTRACTOR_REDIRECT_URL', '$sce', 'SegmentService', '$state', '$scope', '$translate'];
    constructor(AccountService2, ContextProcessorService, DATA_EXTRACTOR_FRAME_URL, DATA_EXTRACTOR_REDIRECT_URL, $sce, SegmentService, $state, $scope, $translate) {
        'ngInject';
        this.AccountService2 = AccountService2;
        this.ContextProcessorService = ContextProcessorService;
        this.DATA_EXTRACTOR_FRAME_URL = DATA_EXTRACTOR_FRAME_URL;
        this.DATA_EXTRACTOR_REDIRECT_URL = DATA_EXTRACTOR_REDIRECT_URL;
        this.$sce = $sce;
        this.SegmentService = SegmentService;
        this.$state = $state;
        this.$scope = $scope;
        this.$translate = $translate;
        this.isFrameEnabled = false;
        this.checkTenantContext = async (ContextProcessorService) => {
            try {
                await ContextProcessorService.waitForInitialization();
                const tenantId = this.ContextProcessorService.tenant.id;
                const tenantPlan = await this.AccountService2.getTenantPlan(tenantId);
                if (tenantPlan.name !== 'standard') {
                    this.frameUrl = this.$sce.trustAsResourceUrl(this.DATA_EXTRACTOR_FRAME_URL);
                    this.isFrameEnabled = true;
                }
            }
            catch (error) {
                console.error('Failed loading page', error);
            }
            finally {
                this.isLoading = false;
            }
        };
        this.user = this.AccountService2.meSync();
        this.webSocketParams = {
            blipDomainUrl,
            blipWebsocketHostName,
            blipWebsocketHostNameTenant,
        };
        this.checkTenantContext(ContextProcessorService);
    }
    async $onInit() {
        await this.checkFeatures();
        this.isLoading = true;
    }
    async checkFeatures() {
        const [isReportMfeEnabled,] = await Promise.all([
            AttendanceFeatures.isReportMfeEnabled(),
        ]);
        this.isReportMfeEnabled = isReportMfeEnabled;
    }
    goToPrevious() {
        this.SegmentService.createApplicationTrack({ trackEvent: DataExtractorConstantsTracks.HELPDESK_REPORTS_DATAEXTRACTOR_EXIT });
        const previousStateName = this.isReportMfeEnabled ? attendanceReportStateNameMfe : attendanceReportStateName;
        this.$state.go(previousStateName, {}, { reload: previousStateName });
    }
    async goToContact() {
        const url = await this.$translate('dataExtractor.noAccess.url');
        window.open(url, '_blank');
    }
}
DataExtractorReportController.$inject = ['AccountService2', 'ContextProcessorService', 'DATA_EXTRACTOR_FRAME_URL', 'DATA_EXTRACTOR_REDIRECT_URL', '$sce', 'SegmentService', '$state', '$scope', '$translate'];
